import React from 'react'
import { HomeRounded, InfoRounded } from '@material-ui/icons'

const listIconStyles = {
    fontSize: '20px',
    color: '#A1A8B3',
    minWidth: '35px',
}

// FORMATO PARA AGREGAR SECCIONES
// Los datos innecesarios pueden agregarse como null o directamente no estar.
// {
//     title: '',
//     menuTitle: '',
//     id: '',
//     icon: </>,
//     content: {
//         subtitle: '',
//         text: '',
//         table: [
//             {
//         -- Puede tener más de un header. Colspan, backgroundColor, color y textAlign son opcionales --
//                 header: [
//                     [
//                         {
//                             text: '',
//                             colspan: 2
//                         },
//                     ]
//                 ],
//                 data: [
//                     {
//                         text: ['', ''],
//                     },
//                     {
//                         text: [''],
//                         colspan: 2,
//                         backgroundColor: '#ffcd34',
//                         color: 'white',
//                         textAlign: 'center'
//                     },
//                 ],
//             },
//         ],
//         example: ``,
//     },
//     -- Menus anidados --
//     submenu: [
//         {
//             menuTitle: '',
//             id: '',
//             content: {
//                 subtitle: '',
//                 text: null,
//             }
//         },
//     ]
// },

const sections = [
    {
        title: 'Introducción',
        menuTitle: 'Introducción',
        icon: <HomeRounded style={listIconStyles} />,
        id: 'intro',
        showSection: false,
        content: null
    },
    {
        title: 'Generalidades',
        menuTitle: 'Generalidades',
        icon: <InfoRounded style={listIconStyles} />,
        id: 'general',
        content: {
            subtitle: null,
            text: 'La interfaz de aplicación está implementada utilizando REST y está disponible mediante HTTPS. Para poder operar contra el sistema de logística de ECommerce de Pudo, el sistema externo deberá autenticarse.\n\n Las credenciales para la autenticación se obtienen mediante la aplicación de ECommerce de Pudo, luego de registrar la tienda. Estas están compuestas por el client id y el client secret. Al autenticarse contra el sistema se generará un token, que debe utilizarse al invocar las operaciones expuestas por la API REST.',
        }
    },
    {
        title: 'Autenticación',
        menuTitle: 'Autenticación',
        id: 'auth',
        content: {
            subtitle: null,
            text: 'El mecanismo de autenticación sigue el estándar OAUTH 2.0, por lo cual, como resultado de la autenticación de usuario contra el sistema, se retorna un token de acceso. Este token de acceso debe ser utilizado cada vez que el sistema externo invoque operaciones de la API REST. El token tiene un tiempo de expiración luego del cual debe ser solicitado nuevamente. \n\n Api ecommerce Sandbox url: \n https://ecommerceapipudo-sandbox.azurewebsites.net/api/token \n\n Api ecommerce Prod url: \n https://ecommerceapipudo.azurewebsites.net/api/token \n\n',
            table: [
                {
                    header: [
                        [
                            {
                                text: 'Invocación',
                                colspan: 2
                            },
                        ]
                    ],
                    data: [
                        {
                            text: ['Método', 'Post'],
                        },
                        {
                            text: ['Base URI', '/api/token'],
                        },
                        {
                            text: ['Tipo de Contenido', 'application/x-www-form-urlencoded'],
                        },
                    ],
                }
            ],
        },
        submenu: [
            {
                // title: 'Request',
                menuTitle: 'Request',
                id: 'auth_request',
                content: {
                    subtitle: 'Request',
                    text: null,
                    table: [
                        {
                            header: [
                                [
                                    {
                                        text: 'Nombre de campo',
                                    },
                                    {
                                        text: 'Tipo',
                                    },
                                    {
                                        text: 'Descripción',
                                    },
                                ]
                            ],
                            data: [
                                {
                                    text: ['grant_type', 'string', 'Define el tipo de autenticación. Para autenticarse contra el sistema, debe utilizarse con el tipo client_credentials.'],
                                },
                                {
                                    text: ['client_id', 'string', 'Id del cliente'],
                                },
                                {
                                    text: ['client_secret', 'string', 'Secret del cliente'],
                                },
                            ],
                        },
                    ],
                    example:
                        `POST /api/token HTTP/1.1\nContent-Type: application/x-www-form-urlencoded\n...\ngrant_type=client_credentials&client_id=833f57fd-4a5e-45b5-bdfd-43b5bb5f0501&client_secret= ExkIrmteDpWt18aOk1X-FizMimq4Wd2Y6OZIWri9dsU`
                }
            },
            {
                // title: 'Response',
                menuTitle: 'Response',
                id: 'auth_response',
                content: {
                    subtitle: 'Response',
                    text: null,
                    table: [
                        {
                            header: [
                                [
                                    {
                                        text: 'Tipo de contenido',
                                    },
                                    {
                                        text: 'application/json',
                                        colspan: 2,
                                        backgroundColor: 'white',
                                        color: '#4A4A4A'
                                    },
                                ],
                                [
                                    {
                                        text: 'Nombre de campo',
                                    },
                                    {
                                        text: 'Tipo',
                                    },
                                    {
                                        text: 'Descripcion',
                                    },
                                ]
                            ],
                            data: [
                                {
                                    text: ['access_token', 'string', 'Token de acceso a ser utilizado en las operaciones'],
                                },
                                {
                                    text: ['token_type', 'string', 'Tipo de token'],
                                },
                            ],
                        },
                    ],
                    example:
                        `HTTP/1.1 200 OK\nContent-Type: application/json;charset=UTF-8\n...\n{\n   "access_token": "AQAAAN...thA",\n   "token_type": "bearer”,\n   "expires_in": 86399\n}`
                }
            },
            {
                title: 'Manejo de errores relacionados con autenticación',
                menuTitle: 'Manejo de errores relacionados con autenticación',
                id: 'auth_errorHandler',
                submenu: [
                    {
                        menuTitle: 'Autenticación Fallida',
                        id: 'auth_error',
                        content: {
                            subtitle: 'Autenticación Fallida',
                            text: 'En caso de una autenticación fallida se retornará un response de error 400 (Bad Request) con el formato: ',
                            table: [
                                {
                                    header: [
                                        [
                                            {
                                                text: 'Tipo de contenido',
                                            },
                                            {
                                                text: 'application/json',
                                                colspan: 2,
                                                backgroundColor: 'white',
                                                color: '#4A4A4A'
                                            },
                                        ],
                                        [
                                            {
                                                text: 'Nombre de campo',
                                            },
                                            {
                                                text: 'Tipo',
                                            },
                                            {
                                                text: 'Descripcion',
                                            },
                                        ]
                                    ],
                                    data: [
                                        {
                                            text: ['error', 'string', 'Error'],
                                        },
                                    ],
                                },
                            ],
                            example:
                                `HTTP/1.1 400 Bad Request\nContent-Type: application/json;UTF-8\n{\n   "error":"invalid_grant"\n}`
                        }
                    },
                    {
                        menuTitle: 'Expiración de token',
                        id: 'auth_tokenExpired',
                        content: {
                            subtitle: 'Expiración de token',
                            text: 'En caso de invocar un método cualquiera sin haberse autenticado previamente en forma exitosa, o si el token utilizado expiró, se retornará un response de error 401 (Unauthorized) con el formato:',
                            table: [
                                {
                                    header: [
                                        [
                                            {
                                                text: 'Tipo de contenido',
                                            },
                                            {
                                                text: 'application/json',
                                                colspan: 2,
                                                backgroundColor: 'white',
                                                color: '#4A4A4A'
                                            },
                                        ],
                                        [
                                            {
                                                text: 'Nombre de campo',
                                            },
                                            {
                                                text: 'Tipo',
                                            },
                                            {
                                                text: 'Descripcion',
                                            },
                                        ]
                                    ],
                                    data: [
                                        {
                                            text: ['Message', 'string', 'Mensaje descriptivo del error'],
                                        },
                                    ],
                                },
                            ],
                            example:
                                `HTTP/1.1 401 Unauthorized\nContent-Type: application/json;charset=UTF-8\n{\n    "Message": "Authorization has been denied for this request."\n}`
                        }
                    },
                ],
            },
        ],
    },
    {
        title: 'Consulta de cotización',
        menuTitle: 'Consulta de cotización',
        id: 'quote',
        content: {
            subtitle: null,
            text: 'Esta operación permite obtener precios para método de envío. Retorna una lista con los métodos de envíos disponibles y las opciones de los mismos en caso de existir.',
            table: [
                {
                    header: [
                        [
                            {
                                text: 'Invocación',
                                colspan: 2
                            },
                        ]
                    ],
                    data: [
                        {
                            text: ['Método', 'Post'],
                        },
                        {
                            text: ['Base URI', '/api/v1/ShippingRates'],
                        },
                        {
                            text: ['Tipo de contenido', 'application/json'],
                        },
                        {
                            text: ['Headers'],
                            colspan: 2,
                            backgroundColor: '#ffcd34',
                            color: 'white',
                            textAlign: 'center'
                        },
                        {
                            text: ['Autorization', 'Bearer {Token}'],
                        },
                    ],
                },
            ],
        },
        submenu: [
            {
                menuTitle: 'Request',
                id: 'quote_request',
                content: {
                    subtitle: 'Request',
                    text: null,
                    table: [
                        {
                            header: [
                                [
                                    {
                                        text: 'Nombre de campo',
                                    },
                                    {
                                        text: 'Tipo',
                                    },
                                    {
                                        text: 'Descripción',
                                    },
                                ]
                            ],
                            data: [
                                {
                                    text: ['Destination', 'AddressInfo', 'Dirección de entrega'],
                                },
                                {
                                    text: ['Items', 'Lista de Items', 'Paquetes a incluir en la órden'],
                                },
                            ],
                        },
                        {
                            header: [
                                [
                                    {
                                        text: 'AddressInfo',
                                        colspan: 3,
                                        backgroundColor: 'white',
                                        color: '#4A4A4A'
                                    },
                                ],
                                [
                                    {
                                        text: 'Nombre de campo',
                                    },
                                    {
                                        text: 'Tipo',
                                    },
                                    {
                                        text: 'Descripción',
                                    },
                                ],
                            ],
                            data: [
                                {
                                    text: ['Address', 'string', 'Calle (Opcional)'],
                                },
                                {
                                    text: ['Number', 'string', 'Número de casa (Opcional)'],
                                },
                                {
                                    text: ['Floor', 'string', 'Piso (Opcional)'],
                                },
                                {
                                    text: ['Locality', 'string', 'Barrio (Opcional)'],
                                },
                                {
                                    text: ['Province', 'string', 'Provincia (Opcional)'],
                                },
                                {
                                    text: ['PostalCode', 'string', 'Código Postal (Opcional)'],
                                },
                            ],
                        },
                        {
                            header: [
                                [
                                    {
                                        text: 'Item',
                                        colspan: 3,
                                        backgroundColor: 'white',
                                        color: '#4A4A4A'
                                    },
                                ],
                                [
                                    {
                                        text: 'Nombre de campo',
                                    },
                                    {
                                        text: 'Tipo',
                                    },
                                    {
                                        text: 'Descripción',
                                    },
                                ],
                            ],
                            data: [
                                {
                                    text: ['SKU', 'string', 'Código único de identificación del producto (Obligatorio)'],
                                },
                                {
                                    text: ['Name', 'string', 'Descripción del producto (Obligatorio)'],
                                },
                                {
                                    text: ['Price', 'decimal', 'Precio del producto'],
                                },
                                {
                                    text: ['WidthInMm', 'long', 'Ancho del paquete en milímetros'],
                                },
                                {
                                    text: ['HeightInMm', 'long', 'Altura del paquete en milímetros'],
                                },
                                {
                                    text: ['DepthInMm', 'long', 'Largo del paquete en milímetros'],
                                },
                                {
                                    text: ['WeightInGrams', 'long', 'Peso del paquete en gramos'],
                                },
                                {
                                    text: ['Quantity', 'long', 'Cantidad (Obligatorio)'],
                                },
                                {
                                    text: ['FreeShipping', 'bool', 'Indica si el producto tiene envió gratuito. En caso de indicarse como gratuito, el precio del envío será cero.'],
                                },
                            ],
                        },
                    ],
                    example: `POST /api/v1/ShippingRates HTTP/1.1\nContent-Type: application/json\nAuthorization: Bearer AQAAAN...thA\n{\n   "destination": {\n      "address": "Enrique Santos Discepolo",\n      "number": "1859",\n      "country": "AR",\n      "city": "Ciudad Autonoma de Buenos Aires",\n      "province": "Ciudad Autonoma de Buenos Aires",\n      "locality": "Valle Escondido",\n      "postalCode": "1051"\n   },\n"items": [{\n      "sku": "prod-001",\n      "name": "Producto de Test",\n      "price": 75,\n      "widthInMm": 200,\n      "heightInMm": 300,\n      "depthInMm": 150,\n      "weightInGrams": 560,\n      "quantity": 3,\n      "freeShipping": false\n   }]\n}`,
                }
            },
            {
                menuTitle: 'Response',
                id: 'quote_response',
                content: {
                    subtitle: 'Response',
                    text: null,
                    table: [
                        {
                            header: [
                                [
                                    {
                                        text: 'Tipo de contenido',
                                    },
                                    {
                                        text: 'application/json',
                                        colspan: 2,
                                        backgroundColor: 'white',
                                        color: '#4A4A4A'
                                    },
                                ],
                                [
                                    {
                                        text: 'Nombre de campo',
                                    },
                                    {
                                        text: 'Tipo',
                                    },
                                    {
                                        text: 'Descripcion',
                                    },
                                ]
                            ],
                            data: [
                                {
                                    text: ['ShippingMethodId', 'long', 'Id del método de envío\nLos métodos de envío disponibles son:\n1-Smart Locker\n3-Envio a Domicilio'],
                                },
                                {
                                    text: ['ShippingMethodName', 'string', 'Nombre del método de envío'],
                                },
                                {
                                    text: ['Cost', 'decimal', 'Costo del envío para la tienda'],
                                },
                                {
                                    text: ['Price', 'decimal', 'Costo del servicio para el cliente'],
                                },
                                {
                                    text: ['Options', 'ShippingRateOption', 'Datos de envío'],
                                },
                            ],
                        },
                        {
                            header: [
                                [
                                    {
                                        text: 'ShippingRateOption',
                                        colspan: 3,
                                        backgroundColor: 'white',
                                        color: '#4A4A4A'
                                    },
                                ],
                                [
                                    {
                                        text: 'Nombre de campo',
                                    },
                                    {
                                        text: 'Tipo',
                                    },
                                    {
                                        text: 'Descripcion',
                                    },
                                ]
                            ],
                            data: [
                                {
                                    text: ['LockerId', 'long', 'Id de locker (en caso de ser destinarse a un locker)'],
                                },
                                {
                                    text: ['MinDeliveryDate', 'string', 'Fecha de mínima entrega estimada'],
                                },
                                {
                                    text: ['MaxDeliveryDate', 'string', 'Fecha de máxima de entrega estimada'],
                                },
                                {
                                    text: ['Latitude', 'double', 'Latitud del Locker'],
                                },
                                {
                                    text: ['Longitude', 'double', 'Longitud del locker'],
                                },
                                {
                                    text: ['Address', 'string', 'Dirección de entrega'],
                                },
                                {
                                    text: ['City', 'string', 'Ciudad de entrega'],
                                },
                                {
                                    text: ['Province', 'string', 'Provincia de entrega'],
                                },
                                {
                                    text: ['Zipcode', 'string', 'Código Postal de entrega'],
                                },
                                {
                                    text: ['Lockername', 'string', 'Nombre del locker para retiro. Solo si es envío a locker'],
                                },
                                {
                                    text: ['LockerLocationDetails', 'string', 'Ubicación del locker. Solo si es envío en locker'],
                                },
                            ],
                        },
                    ],
                    example:
                        `HTTP/1.1 200 OK\n[\n   {\n      "shippingMethodId": 1,\n      "shippingMethodName": "PUDO Smart Locker",\n      "cost": 120.00000,\n      "price": 120.00000,\n      "options": [\n         {\n            "lockerId": 3,\n            "minDeliveryDate": "2021-07-20T00:00:00-0300",\n            "maxDeliveryDate": "2021-07-26T23:59:59-0300",\n            "latitude": -34.60447607,\n            "longitude": -58.39602751,\n            "address": "Av. Callao 1601 ",\n            "city": "Ciudad Autonoma de Buenos Aires",\n            "province": "Ciudad Autónoma de Buenos Aires",\n            "zipcode": null,\n            "lockerName": "OPEN25 L106",\n            "lockerLocationDetails" "Abiert 2 hs."\n         },\n         {\n            "lockerId" 34,\n            "minDeliveryDate" "2021-07-20T00:00:00-0300",\n            "maxDeliveryDate" "2021-07-26T23:59:59-0300",\n            "latitude" -34.6009139,\n            "longitude" -58.396953,\n            "address" "Juní 70 - C1026ABO - CABA",\n            "city": "CABA",\n            "province": "Ciudad Autonoma de Buenos Aires",\n            "zipcode": null,\n            "lockerName": "OPEN25 L157",\n            "lockerLocationDetails": ""\n         },\n         {\n            "lockerId": 1,\n            "minDeliveryDate": "2021-07-20T00:00:00-0300",\n            "maxDeliveryDate": "2021-07-26T23:59:59-0300",\n            "latitude": -34.6037820293518,\n            "longitude": -58.3931908981476,\n            "address": "[DEV] Enrique Santos Discepolo 1859",\n            "city": "CABA",\n            "province": "Ciudad Autónoma de Buenos Aires",\n            "zipcode": null,\n            "lockerName": "The Beast",\n            "lockerLocationDetails": "Piso 6"\n         },\n         {\n            "lockerId": 4,\n            "minDeliveryDate": "2021-07-20T00:00:00-0300"\n            "maxDeliveryDate": "2021-07-26T23:59:59-0300",\n            "latitude": -34.60580912,\n            "longitude": -58.39449865,\n            "address": "Derqui 33",\n            "city": "Cordoba",\n            "province": "Buenos Aires",\n            "zipcode": null,\n            "lockerLocationDetails":"Lunes a sábado 9:00 a 22:00hs/Domingo 10:00 a 21:00hs"\n         },\n         {\n            "lockerId": 5,\n            "minDeliveryDate": "2021-07-20T00:00:00-0300",\n            "maxDeliveryDate": "2021-07-26T23:59:59-0300",\n            "latitude": -34.59956561,\n            "longitude": -58.39342037,\n            "address": "Av. Sagrada Familia 1305",\n            "city": "Cordoba",\n            "province": "Ciudad Autónoma de Buenos Aires",\n            "zipcode": null,\n            "lockerName": "MINI LIBERTAD SAGRADA FAMILIA",\n            "lockerLocationDetails": "Lunes a sábado 9:00 a 22:00hs/Domingo 10:00 a 21:00hs"\n         }\n         ]\n      },\n      {\n         "shippingMethodId": 3,\n         "shippingMethodName": "PUDO Envío a Domicilio",\n         "cost": 250.00000,\n         "price": 250.00000,\n         "options": [\n         {\n            "lockerId": null,\n            "maxDeliveryDate": "2021-07-26T23:59:59-0300",\n            "latitude": null,\n            "longitude": null,\n            "address": "",\n            "city": "",\n            "province": "",\n            "zipcode": "",\n            "lockerName": "",\n         "   lockerLocationDetails": ""\n         }\n      ]\n   }\n]`
                }
            },
        ]
    },
    {
        title: 'Creación de órdenes',
        menuTitle: 'Creación de órdenes',
        id: 'orderCreate',
        content: {
            subtitle: null,
            text: 'Esta operación permite crear órdenes en el sistema de PUDO.',
            table: [
                {
                    header: [
                        [
                            {
                                text: 'Invocación',
                                colspan: 2
                            },
                        ]
                    ],
                    data: [
                        {
                            text: ['Método', 'Post'],
                        },
                        {
                            text: ['Base URI', '/api/v1/Orders'],
                        },
                        {
                            text: ['Tipo de contenido', 'application/json'],
                        },
                        {
                            text: ['Headers'],
                            colspan: 2,
                            backgroundColor: '#ffcd34',
                            color: 'white',
                            textAlign: 'center'
                        },
                        {
                            text: ['Autorization', 'Bearer {Token}'],
                        },
                    ],
                },
            ],
        },
        submenu: [
            {
                menuTitle: 'Request',
                id: 'orderCreate_request',
                content: {
                    subtitle: 'Request',
                    text: null,
                    table: [
                        {
                            header: [
                                [
                                    {
                                        text: 'Nombre de campo',
                                    },
                                    {
                                        text: 'Tipo',
                                    },
                                    {
                                        text: 'Descripción',
                                    },
                                ]
                            ],
                            data: [
                                {
                                    text: ['OrderId', 'long', 'Id de Orden en el ECommerce. Se requiere que sea univoco por Tienda (Obligatorio)'],
                                },
                                {
                                    text: ['OrderNumber', 'long', 'Número de orden en la tienda. En caso de no contar con número de orden enviar el mismo que el Id (Obligatorio)'],
                                },
                                {
                                    text: ['DepositCode', 'string', 'Código de depósito para la reserva en locker. Si no se provee se generará un código de forma automática.'],
                                },
                                {
                                    text: ['Customer', 'Customer', 'Datos del cliente.'],
                                },
                                {
                                    text: ['ShippingInfo', 'ShippingInfo', 'Método de envío y datos del destinatario'],
                                },
                                {
                                    text: ['Items', 'Lista de items', 'Productos de la órden.'],
                                },
                            ],
                        },
                        {
                            header: [
                                [
                                    {
                                        text: 'Customer',
                                        colspan: 3,
                                        backgroundColor: 'white',
                                        color: '#4A4A4A'
                                    },
                                ],
                                [
                                    {
                                        text: 'Nombre de campo',
                                    },
                                    {
                                        text: 'Tipo',
                                    },
                                    {
                                        text: 'Descripción',
                                    },
                                ],
                            ],
                            data: [
                                {
                                    text: ['Name', 'string', 'Nombre del destinatario (Obligatorio)'],
                                },
                                {
                                    text: ['Mail', 'string', 'Email del destinatario (Obligatorio)'],
                                },
                                {
                                    text: ['PhoneNumber', 'string', 'Teléfono de destinatario.'],
                                },
                            ],
                        },
                        {
                            header: [
                                [
                                    {
                                        text: 'ShippingInfo',
                                        colspan: 3,
                                        backgroundColor: 'white',
                                        color: '#4A4A4A'
                                    },
                                ],
                                [
                                    {
                                        text: 'Nombre de campo',
                                    },
                                    {
                                        text: 'Tipo',
                                    },
                                    {
                                        text: 'Descripción',
                                    },
                                ],
                            ],
                            data: [
                                {
                                    text: ['ShippingMethodId', 'long', 'Id del método de envío (Obligatorio)'],
                                },
                                {
                                    text: ['LockerId', 'long', 'Id del locker de destino. Obligatorio si ShippingMethodId = 1 (retiro en locker)'],
                                },
                                {
                                    text: ['Destination', 'AddressInfo', 'Información de dirección de entrega. Obligatorio si ShippingMethodId = 3 (entrega a domicilio)'],
                                },
                            ],
                        },
                        {
                            header: [
                                [
                                    {
                                        text: 'AddressInfo',
                                        colspan: 3,
                                        backgroundColor: 'white',
                                        color: '#4A4A4A'
                                    },
                                ],
                                [
                                    {
                                        text: 'Nombre de campo',
                                    },
                                    {
                                        text: 'Tipo',
                                    },
                                    {
                                        text: 'Descripción',
                                    },
                                ],
                            ],
                            data: [
                                {
                                    text: ['Address', 'string', 'Calle (Obligatorio)'],
                                },
                                {
                                    text: ['Number', 'string', 'Número de casa'],
                                },
                                {
                                    text: ['Floor', 'string', 'Piso'],
                                },
                                {
                                    text: ['Apartment', 'string', 'Número de departamento'],
                                },
                                {
                                    text: ['Locality', 'string', 'Barrio'],
                                },
                                {
                                    text: ['City', 'string', 'Ciudad (Obligatorio)'],
                                },
                                {
                                    text: ['Province', 'string', 'Provincia (Obligatorio)'],
                                },
                                {
                                    text: ['Country', 'string', 'País (Obligatorio)'],
                                },
                                {
                                    text: ['PostalCode', 'string', 'Código Postal (Obligatorio)'],
                                },
                            ],
                        },
                        {
                            header: [
                                [
                                    {
                                        text: 'Item',
                                        colspan: 3,
                                        backgroundColor: 'white',
                                        color: '#4A4A4A'
                                    },
                                ],
                                [
                                    {
                                        text: 'Nombre de campo',
                                    },
                                    {
                                        text: 'Tipo',
                                    },
                                    {
                                        text: 'Descripción',
                                    },
                                ],
                            ],
                            data: [
                                {
                                    text: ['SKU', 'string', 'Código único de identificación del producto (Obligatorio)'],
                                },
                                {
                                    text: ['Name', 'string', 'Descripción del producto (Obligatorio)'],
                                },
                                {
                                    text: ['Price', 'decimal', 'Precio del producto'],
                                },
                                {
                                    text: ['WidthInMm', 'long', 'Ancho del paquete en milímetros'],
                                },
                                {
                                    text: ['HeightInMm', 'long', 'Altura del paquete en milímetros'],
                                },
                                {
                                    text: ['DepthInMm', 'long', 'Largo del paquete en milímetros'],
                                },
                                {
                                    text: ['WeightInGrams', 'long', 'Peso del paquete en gramos'],
                                },
                                {
                                    text: ['Quantity', 'long', 'Cantidad (Obligatorio)'],
                                },
                                {
                                    text: ['FreeShipping', 'bool', 'Indica si el producto tiene envió gratuito.'],
                                },
                            ],
                        },
                    ],
                    example: `POST /api/v1/Orders HTTP/1.1\nContent-Type: application/json\nAuthorization: Bearer AQAAAN...thA\n\n{\n   "orderId": 202106181,\n   "orderNumber": 202106181,\n   "depositCode": "202106181",\n   "customer": {\n      "name": "roberto",\n      "mail": "mail@ejemplo.com"\n   },\n   "shippingInfo": {\n      "shippingMethodId": 3,\n      "destination": {\n         "address": "Av. Belgrano",\n         "province": "Ciudad Autonoma de Buenos Aires",\n         "country": "AR",\n         "city": "CABA",\n         "postalCode": 1051\n      }\n   },\n   "items": [{\n      "sku": "prod-001",\n      "name": "producto 1",\n      "price": 50,\n      "widthInMm": 100,\n      "heightInMm": 100,\n      "depthInMm": 100,\n      "weightInGrams": 100,\n      "quantity": 1,\n      "freeShipping": false\n   }]\n}`,
                }
            },
            {
                menuTitle: 'Response',
                id: 'orderCreate_response',
                content: {
                    subtitle: 'Response',
                    text: 'Retorna 200 OK en caso de que se haya creado la orden de forma exitosa',
                    example:
                        `HTTP/1.1 200 OK\nContent-Length: 0`
                }
            },
        ]

    },
    {
        title: 'Creación de órdenes integradas',
        menuTitle: 'Creación de órdenes integradas',
        id: 'integratedOrderCreate',
        content: {
            subtitle: null,
            text: 'Permite crear una orden con una máxima integración con el portal web.',
            table: [
                {
                    header: [
                        [
                            {
                                text: 'Invocación',
                                colspan: 2
                            },
                        ]
                    ],
                    data: [
                        {
                            text: ['Método', 'Post'],
                        },
                        {
                            text: ['Base URI', '/api/v1/Order'],
                        },
                        {
                            text: ['Tipo de contenido', 'application/json'],
                        },
                        {
                            text: ['Headers'],
                            colspan: 2,
                            backgroundColor: '#ffcd34',
                            color: 'white',
                            textAlign: 'center'
                        },
                        {
                            text: ['Autorization', 'Bearer {Token}'],
                        },
                    ],
                },
            ],
        },
        submenu: [
            {
                menuTitle: 'Request',
                id: 'integratedOrderCreate_request',
                content: {
                    subtitle: 'Request',
                    text: null,
                    table: [
                        {
                            header: [
                                [
                                    {
                                        text: 'Nombre de campo',
                                    },
                                    {
                                        text: 'Tipo',
                                    },
                                    {
                                        text: 'Descripción',
                                    },
                                ]
                            ],
                            data: [
                                {
                                    text: ['PlatformOrderId', 'long', 'Identificador único de orden. Se requiere que sea univoco por Tienda (Obligatorio)'],
                                },
                                {
                                    text: ['PlatformOrderNumber', 'long', 'Número de orden en la tienda. En caso de no contar con número de orden enviar el mismo que el Id (Obligatorio)'],
                                },
                                {
                                    text: ['DepositCode', 'string', 'Código de depósito para la reserva en locker. Si no se provee se generará un código de forma automática.'],
                                },
                                {
                                    text: ['Customer', 'Customer', 'Datos del cliente.'],
                                },
                                {
                                    text: ['ShippingInfo', 'ShippingInfo', 'Método de envío y datos del destinatario'],
                                },
                                {
                                    text: ['CreateReserve', 'bool', 'Cuando se indica True, luego de crear la orden se creará la reserva de espacio en el Smart Locker.'],
                                },
                                {
                                    text: ['Metrics', 'OrderMetrics', 'Medidas y peso del paquete.'],
                                }, {
                                    text: ['Items', 'Lista de items', 'Productos de la órden.'],
                                },
                            ],
                        },
                        {
                            header: [
                                [
                                    {
                                        text: 'CustomSecurity',
                                        colspan: 3,
                                        backgroundColor: 'white',
                                        color: '#4A4A4A'
                                    },
                                ],
                                [
                                    {
                                        text: 'Nombre de campo',
                                    },
                                    {
                                        text: 'Tipo',
                                    },
                                    {
                                        text: 'Descripción',
                                    },
                                ],
                            ],
                            data: [
                                {
                                    text: ['RequestSignature', 'bool', 'Solicitar firma'],
                                },
                                {
                                    text: ['RequestToken', 'bool', 'Solicitar token'],
                                },
                                {
                                    text: ['CustomCode', 'CustomCode', 'Datos para solicitar código de seguridad'],
                                },
                            ],
                        },
                        {
                            header: [
                                [
                                    {
                                        text: 'CustomCode',
                                        colspan: 3,
                                        backgroundColor: 'white',
                                        color: '#4A4A4A'
                                    },
                                ],
                                [
                                    {
                                        text: 'Nombre de campo',
                                    },
                                    {
                                        text: 'Tipo',
                                    },
                                    {
                                        text: 'Descripción',
                                    },
                                ],
                            ],
                            data: [
                                {
                                    text: ['Type', 'long', '2 (Dni) o 3 (AlphaNumeric)'],
                                },
                                {
                                    text: ['Code', 'string', 'Código solicitado'],
                                },
                            ],
                        },
                        {
                            header: [
                                [
                                    {
                                        text: 'Customer',
                                        colspan: 3,
                                        backgroundColor: 'white',
                                        color: '#4A4A4A'
                                    },
                                ],
                                [
                                    {
                                        text: 'Nombre de campo',
                                    },
                                    {
                                        text: 'Tipo',
                                    },
                                    {
                                        text: 'Descripción',
                                    },
                                ],
                            ],
                            data: [
                                {
                                    text: ['Name', 'string', 'Nombre del destinatario (Obligatorio)'],
                                },
                                {
                                    text: ['Mail', 'string', 'Email del destinatario (Obligatorio)'],
                                },
                                {
                                    text: ['PhoneNumber', 'string', 'Teléfono de destinatario.'],
                                },
                            ],
                        },
                        {
                            header: [
                                [
                                    {
                                        text: 'ShippingInfo',
                                        colspan: 3,
                                        backgroundColor: 'white',
                                        color: '#4A4A4A'
                                    },
                                ],
                                [
                                    {
                                        text: 'Nombre de campo',
                                    },
                                    {
                                        text: 'Tipo',
                                    },
                                    {
                                        text: 'Descripción',
                                    },
                                ],
                            ],
                            data: [
                                {
                                    text: ['ShippingMethodId', 'long', 'Id del método de envío (Obligatorio)'],
                                },
                                {
                                    text: ['LockerId', 'long', 'Id del locker de destino. Obligatorio si ShippingMethodId = 1 (retiro en locker)'],
                                },
                                {
                                    text: ['Destination', 'AddressInfo', 'Información de dirección de entrega. Obligatorio si ShippingMethodId = 3 (entrega a domicilio)'],
                                },
                            ],
                        },
                        {
                            header: [
                                [
                                    {
                                        text: 'AddressInfo',
                                        colspan: 3,
                                        backgroundColor: 'white',
                                        color: '#4A4A4A'
                                    },
                                ],
                                [
                                    {
                                        text: 'Nombre de campo',
                                    },
                                    {
                                        text: 'Tipo',
                                    },
                                    {
                                        text: 'Descripción',
                                    },
                                ],
                            ],
                            data: [
                                {
                                    text: ['Address', 'string', 'Calle (Obligatorio)'],
                                },
                                {
                                    text: ['Number', 'string', 'Número de casa'],
                                },
                                {
                                    text: ['Floor', 'string', 'Piso'],
                                },
                                {
                                    text: ['Apartment', 'string', 'Número de departamento'],
                                },
                                {
                                    text: ['Locality', 'string', 'Barrio'],
                                },
                                {
                                    text: ['City', 'string', 'Ciudad (Obligatorio)'],
                                },
                                {
                                    text: ['Province', 'string', 'Provincia (Obligatorio)'],
                                },
                                {
                                    text: ['Country', 'string', 'País (Obligatorio)'],
                                },
                                {
                                    text: ['PostalCode', 'string', 'Código Postal (Obligatorio)'],
                                },
                            ],
                        },
                        {
                            header: [
                                [
                                    {
                                        text: 'OrderMetrics',
                                        colspan: 3,
                                        backgroundColor: 'white',
                                        color: '#4A4A4A'
                                    },
                                ],
                                [
                                    {
                                        text: 'Nombre de campo',
                                    },
                                    {
                                        text: 'Tipo',
                                    },
                                    {
                                        text: 'Descripción',
                                    },
                                ],
                            ],
                            data: [
                                {
                                    text: ['WidthInMm', 'long', 'Ancho en milímetros'],
                                },
                                {
                                    text: ['HeightInMm', 'long', 'Alto en milímetros'],
                                },
                                {
                                    text: ['DepthInMm', 'long', 'Largo en milímetros'],
                                },
                                {
                                    text: ['WeightInGrams', 'long', 'Peso en gramos'],
                                },
                            ],
                        },
                        {
                            header: [
                                [
                                    {
                                        text: 'Item',
                                        colspan: 3,
                                        backgroundColor: 'white',
                                        color: '#4A4A4A'
                                    },
                                ],
                                [
                                    {
                                        text: 'Nombre de campo',
                                    },
                                    {
                                        text: 'Tipo',
                                    },
                                    {
                                        text: 'Descripción',
                                    },
                                ],
                            ],
                            data: [
                                {
                                    text: ['SKU', 'string', 'Código único de identificación del producto (Obligatorio)'],
                                },
                                {
                                    text: ['Name', 'string', 'Descripción del producto (Obligatorio)'],
                                },
                                {
                                    text: ['Price', 'decimal', 'Precio del producto'],
                                },
                                {
                                    text: ['WidthInMm', 'long', 'Ancho del paquete en milímetros'],
                                },
                                {
                                    text: ['HeightInMm', 'long', 'Altura del paquete en milímetros'],
                                },
                                {
                                    text: ['DepthInMm', 'long', 'Largo del paquete en milímetros'],
                                },
                                {
                                    text: ['WeightInGrams', 'long', 'Peso del paquete en gramos'],
                                },
                                {
                                    text: ['Quantity', 'long', 'Cantidad (Obligatorio)'],
                                },
                                {
                                    text: ['FreeShipping', 'bool', 'Indica si el producto tiene envió gratuito.'],
                                },
                            ],
                        },
                    ],
                    example: `POST /api/v1/Order HTTP/1.1\nContent-Type: application/json\nAuthorization: Bearer AQAAAN...thA\n\n{\n   "platformOrderId": 2006,\n   "platformOrderNumber": 2006,\n   "depositCode": "202106181",\n   "customSecurity": {\n      "requestSignature": true,\n      "requestToken": true,\n      "customCode": {\n         "type": "Alphanumeric",\n         "code": "CODIGO99"\n      }\n   },\n   "customer": {\n      "name": "roberto",\n      "mail": "mail@ejemplo.com",\n      "phoneNumber": 1199994444\n   },\n   "shippingInfo": {\n      "shippingMethodId": 3,\n      "destination": {\n         "address": "Av. Belgrano",\n         "province": "Ciudad Autonoma de Buenos Aires",\n         "country": "AR",\n         "city": "CABA",\n          "postalCode": 1051\n      }\n   },\n   "createReserve": true,\n   "metrics": {\n      "widthInMm": 150,\n      "heightInMm": 150,\n      "depthInMm": 150,\n      "weightInGrams": 300\n   },\n   "items": [{\n      "sku": "prod-001",\n      "name": "producto 1",\n      "price": 50,\n      "widthInMm": 100,\n      "heightInMm": 100,\n      "depthInMm": 100,\n      "weightInGrams": 100,\n      "quantity": 1,\n      "freeShipping": false\n   }]\n}`,
                }
            },
            {
                menuTitle: 'Response',
                id: 'integratedOrderCreate_response',
                content: {
                    subtitle: 'Response',
                    text: 'Retorna 200 OK en caso de que se haya creado la orden de forma exitosa',
                    example:
                        `HTTP/1.1 200 OK\nContent-Length: 0`
                }
            },
        ]

    },
    {
        title: 'Cancelación de órdenes',
        menuTitle: 'Cancelación de órdenes',
        id: 'cancelOrder',
        content: {
            subtitle: null,
            text: 'Permite cancelar una orden del sistema PUDO.',
            table: [
                {
                    header: [
                        [
                            {
                                text: 'Invocación',
                                colspan: 2
                            },
                        ]
                    ],
                    data: [
                        {
                            text: ['Método', 'Post'],
                        },
                        {
                            text: ['Base URI', '/api/v1/Order/{platformOrderId}/cancel'],
                        },
                        {
                            text: ['Tipo de contenido', 'application/json'],
                        },
                        {
                            text: ['Headers'],
                            colspan: 2,
                            backgroundColor: '#ffcd34',
                            color: 'white',
                            textAlign: 'center'
                        },
                        {
                            text: ['Autorization', 'Bearer {Token}'],
                        },
                    ],
                },
            ],
        },
        submenu: [
            {
                menuTitle: 'Request',
                id: 'cancelOrder_request',
                content: {
                    subtitle: 'Request',
                    text: null,
                    table: [
                        {
                            header: [
                                [
                                    {
                                        text: 'Nombre de campo',
                                    },
                                    {
                                        text: 'Tipo',
                                    },
                                    {
                                        text: 'Descripción',
                                    },
                                ]
                            ],
                            data: [
                                {
                                    text: ['platformOrderId', 'long', 'Id de la orden en la plataforma'],
                                },
                            ],
                        },
                    ],
                    example: `POST /api/v1/order/202106181/cancel HTTP/1.1\nContent-Type: application/json\nAuthorization: Bearer AQAAAN...thA`,
                }
            },
            {
                menuTitle: 'Response',
                id: 'cancelOrder_response',
                content: {
                    subtitle: 'Response',
                    text: 'Retorna 200 OK en caso de que se haya cancelado la orden de forma exitosa',
                    example:
                        `HTTP/1.1 200 OK\nContent-Length: 0`
                }
            },
        ]

    },
    {
        title: 'Cancelación de órdenes con paquete depositado',
        menuTitle: 'Cancelación de órdenes con paquete depositado',
        id: 'cancelDepositedOrder',
        content: {
            subtitle: null,
            text: 'Permite cancelar una orden del sistema PUDO que ya se encuentra depositada en el locker.',
            table: [
                {
                    header: [
                        [
                            {
                                text: 'Invocación',
                                colspan: 2
                            },
                        ]
                    ],
                    data: [
                        {
                            text: ['Método', 'Post'],
                        },
                        {
                            text: ['Base URI', '/api/v1/Order/{platformOrderId}/cancelDeposited'],
                        },
                        {
                            text: ['Tipo de contenido', 'application/json'],
                        },
                        {
                            text: ['Headers'],
                            colspan: 2,
                            backgroundColor: '#ffcd34',
                            color: 'white',
                            textAlign: 'center'
                        },
                        {
                            text: ['Autorization', 'Bearer {Token}'],
                        },
                    ],
                },
            ],
        },
        submenu: [
            {
                menuTitle: 'Request',
                id: 'cancelDepositedOrder_request',
                content: {
                    subtitle: 'Request',
                    text: null,
                    table: [
                        {
                            header: [
                                [
                                    {
                                        text: 'Nombre de campo',
                                    },
                                    {
                                        text: 'Tipo',
                                    },
                                    {
                                        text: 'Descripción',
                                    },
                                ]
                            ],
                            data: [
                                {
                                    text: ['platformOrderId', 'long', 'Id de la orden en la plataforma'],
                                },
                            ],
                        },
                    ],
                    example: `POST /api/v1/order/202106181/cancelDeposited HTTP/1.1\nContent-Type: application/json\nAuthorization: Bearer AQAAAN...thA`,
                }
            },
            {
                menuTitle: 'Response',
                id: 'cancelDepositedOrder_response',
                content: {
                    subtitle: 'Response',
                    text: 'Retorna 200 OK en caso de que se haya cancelado la orden de forma exitosa',
                    example:
                        `HTTP/1.1 200 OK\nContent-Length: 0`
                }
            },
        ]

    },
    {
        title: 'Obtención de órdenes',
        menuTitle: 'Obtención de órdenes',
        id: 'orderGet',
        content: {
            subtitle: null,
            text: 'Permite crear una orden con una máxima integración con el portal web.',
            table: [
                {
                    header: [
                        [
                            {
                                text: 'Invocación',
                                colspan: 2
                            },
                        ]
                    ],
                    data: [
                        {
                            text: ['Método', 'GET'],
                        },
                        {
                            text: ['Base URI', '/api/v1/Orders/{orderId}'],
                        },
                        {
                            text: ['Tipo de contenido', 'application/json'],
                        },
                        {
                            text: ['Headers'],
                            colspan: 2,
                            backgroundColor: '#ffcd34',
                            color: 'white',
                            textAlign: 'center'
                        },
                        {
                            text: ['Autorization', 'Bearer {Token}'],
                        },
                    ],
                },
            ],
        },
        submenu: [
            {
                menuTitle: 'Request',
                id: 'orderGet_request',
                content: {
                    subtitle: 'Request',
                    text: null,
                    table: [
                        {
                            header: [
                                [
                                    {
                                        text: 'Nombre de campo',
                                    },
                                    {
                                        text: 'Tipo',
                                    },
                                    {
                                        text: 'Descripción',
                                    },
                                ]
                            ],
                            data: [
                                {
                                    text: ['OrderId', 'long', 'Id de la orden en la plataforma'],
                                },
                            ],
                        },
                    ],
                    example: `GET /api/v1/orders/202106181 HTTP/1.1\nContent-Type: application/json\nAuthorization: Bearer AQAAAN...thA`,
                }
            },
            {
                menuTitle: 'Response',
                id: 'orderGet_response',
                content: {
                    subtitle: 'Response',
                    table: [
                        {
                            header: [
                                [
                                    {
                                        text: 'Tipo de contenido',
                                    },
                                    {
                                        text: 'application/json',
                                        colspan: 2,
                                        backgroundColor: 'white',
                                        color: '#4A4A4A'
                                    },
                                ],
                                [
                                    {
                                        text: 'Nombre de campo',
                                    },
                                    {
                                        text: 'Tipo',
                                    },
                                    {
                                        text: 'Descripcion',
                                    },
                                ]
                            ],
                            data: [
                                {
                                    text: ['OrderId', 'long', 'Id de la orden en la plataforma'],
                                },
                                {
                                    text: ['OrderNumber', 'long', 'Número de órden en la tienda'],
                                },
                                {
                                    text: ['Customer', 'Customer', 'Datos del cliente'],
                                },
                                {
                                    text: ['ShippingInfo', 'ShippingInfo', 'Método de envío y datos del destinatario'],
                                },
                            ],
                        },

                        {
                            header: [
                                [
                                    {
                                        text: 'Customer',
                                        colspan: 3,
                                        backgroundColor: 'white',
                                        color: '#4A4A4A'
                                    },
                                ],
                                [
                                    {
                                        text: 'Nombre de campo',
                                    },
                                    {
                                        text: 'Tipo',
                                    },
                                    {
                                        text: 'Descripción',
                                    },
                                ],
                            ],
                            data: [
                                {
                                    text: ['Name', 'string', 'Nombre del destinatario'],
                                },
                                {
                                    text: ['Mail', 'string', 'Email del destinatario'],
                                },
                                {
                                    text: ['PhoneNumber', 'string', 'Teléfono de destinatario.'],
                                },
                            ],
                        },
                        {
                            header: [
                                [
                                    {
                                        text: 'ShippingInfo',
                                        colspan: 3,
                                        backgroundColor: 'white',
                                        color: '#4A4A4A'
                                    },
                                ],
                                [
                                    {
                                        text: 'Nombre de campo',
                                    },
                                    {
                                        text: 'Tipo',
                                    },
                                    {
                                        text: 'Descripción',
                                    },
                                ],
                            ],
                            data: [
                                {
                                    text: ['ShippingMethodId', 'long', 'Id del método de envío'],
                                },
                                {
                                    text: ['LockerId', 'long', 'Id del locker de destino'],
                                },
                                {
                                    text: ['Destination', 'AddressInfo', 'Información de dirección de entrega'],
                                },
                            ],
                        },
                        {
                            header: [
                                [
                                    {
                                        text: 'AddressInfo',
                                        colspan: 3,
                                        backgroundColor: 'white',
                                        color: '#4A4A4A'
                                    },
                                ],
                                [
                                    {
                                        text: 'Nombre de campo',
                                    },
                                    {
                                        text: 'Tipo',
                                    },
                                    {
                                        text: 'Descripción',
                                    },
                                ],
                            ],
                            data: [
                                {
                                    text: ['Address', 'string', 'Calle'],
                                },
                                {
                                    text: ['Number', 'string', 'Número de casa'],
                                },
                                {
                                    text: ['Floor', 'string', 'Piso'],
                                },
                                {
                                    text: ['Apartment', 'string', 'Número de departamento'],
                                },
                                {
                                    text: ['Locality', 'string', 'Barrio'],
                                },
                                {
                                    text: ['Province', 'string', 'Provincia'],
                                },
                                {
                                    text: ['Country', 'string', 'País'],
                                },
                                {
                                    text: ['PostalCode', 'string', 'Código Postal'],
                                },
                            ],
                        },
                    ],
                    example:
                        `HTTP/1.1 200 OK\nContent-Type: application/json\n{\n   "orderId": 202106181,\n   "orderNumber": 202106181,\n   "customer": {\n      "name": null,\n      "mail": "mail@ejemplo.com",\n      "phoneNumber": null\n   },\n   "shippingInfo": {\n      "shippingMethodId": 1,\n      "lockerId": 3,\n      "destination": null\n   },\n   "items": [\n      {\n         "sku": "prod-001",\n         "name": "producto 1",\n         "price": 50.00,\n         "widthInMm": 100,\n         "heightInMm": 100,\n         "depthInMm": 100,\n         "weightInGrams": 100,\n         "quantity": 1,\n         "freeShipping": false\n      }\n   ]\n}`
                }
            },
        ]

    },
    {
        title: 'Obtención de la URL de seguimiento de una orden',
        menuTitle: 'Obtención de la URL de seguimiento de una orden',
        id: 'orderGetUrl',
        content: {
            subtitle: null,
            text: 'Permite obtener la URL con de seguimiento de una orden.',
            table: [
                {
                    header: [
                        [
                            {
                                text: 'Invocación',
                                colspan: 2
                            },
                        ]
                    ],
                    data: [
                        {
                            text: ['Método', 'GET'],
                        },
                        {
                            text: ['Base URI', '/api/v1/trackingurl/{orderId}'],
                        },
                        {
                            text: ['Tipo de contenido', 'application/json'],
                        },
                        {
                            text: ['Headers'],
                            colspan: 2,
                            backgroundColor: '#ffcd34',
                            color: 'white',
                            textAlign: 'center'
                        },
                        {
                            text: ['Autorization', 'Bearer {Token}'],
                        },
                    ],
                },
            ],
        },
        submenu: [
            {
                menuTitle: 'Request',
                id: 'orderGetUrl_request',
                content: {
                    subtitle: 'Request',
                    text: null,
                    table: [
                        {
                            header: [
                                [
                                    {
                                        text: 'Nombre de campo',
                                    },
                                    {
                                        text: 'Tipo',
                                    },
                                    {
                                        text: 'Descripción',
                                    },
                                ]
                            ],
                            data: [
                                {
                                    text: ['OrderId', 'long', 'Id de la orden en la plataforma'],
                                },
                            ],
                        },
                    ],
                    example: `GET /api/v1/trackingurl/202106181 HTTP/1.1\nContent-Type: application/json\nAuthorization: Bearer AQAAAN...thA`,
                }
            },
            {
                menuTitle: 'Response',
                id: 'orderGetUrl_response',
                content: {
                    subtitle: 'Response',
                    text: 'La respuesta es la URL de seguimiento.',
                    example:
                        `HTTP/1.1 200 OK\n"https://ecommerce.pudolatam.com/App/BackOffice/trackingForm?code=0500006171382"`
                }
            },
        ]
    },
    {
        title: 'Obtención de la etiqueta de una orden',
        menuTitle: 'Obtención de la etiqueta de una orden',
        id: 'orderGetLabel',
        content: {
            subtitle: null,
            text: 'Esta operación permite obtener la etiqueta de la orden para su impresión.',
            table: [
                {
                    header: [
                        [
                            {
                                text: 'Invocación',
                                colspan: 2
                            },
                        ]
                    ],
                    data: [
                        {
                            text: ['Método', 'GET'],
                        },
                        {
                            text: ['Base URI', '/api/v1/labels/{orderId}'],
                        },
                        {
                            text: ['Tipo de contenido', 'application/json'],
                        },
                        {
                            text: ['Headers'],
                            colspan: 2,
                            backgroundColor: '#ffcd34',
                            color: 'white',
                            textAlign: 'center'
                        },
                        {
                            text: ['Autorization', 'Bearer {Token}'],
                        },
                    ],
                },
            ],
        },
        submenu: [
            {
                menuTitle: 'Request',
                id: 'orderGetLabel_request',
                content: {
                    subtitle: 'Request',
                    text: null,
                    table: [
                        {
                            header: [
                                [
                                    {
                                        text: 'Nombre de campo',
                                    },
                                    {
                                        text: 'Tipo',
                                    },
                                    {
                                        text: 'Descripción',
                                    },
                                ]
                            ],
                            data: [
                                {
                                    text: ['OrderId', 'long', 'Id de la orden en la plataforma'],
                                },
                            ],
                        },
                    ],
                    example: `GET /api/v1/labels/202105265 HTTP/1.1\nContent-Type: application/json\nAuthorization: Bearer AQAAAN...thA `,
                }
            },
            {
                menuTitle: 'Response',
                id: 'orderGetUrl_response',
                content: {
                    subtitle: 'Response',
                    text: 'La respuesta es un archivo PDF con la etiqueta',
                    example:
                        `HTTP/1.1 200 OK\nContent-Length: 165645\nContent-Type: application/pdf\n%PDF-1.3\n1 0 obj\n[/PDF /Text /ImageB /ImageC /ImageI]\nendobj\n8 0 obj\n…`
                }
            },
        ]

    },
    {
        title: 'Obtención de estados',
        menuTitle: 'Obtención de estados',
        id: 'getStatus',
        content: {
            subtitle: null,
            text: 'Esta operación permite obtener los cambios de estados de orden.',
            table: [
                {
                    header: [
                        [
                            {
                                text: 'Invocación',
                                colspan: 2
                            },
                        ]
                    ],
                    data: [
                        {
                            text: ['Método', 'GET'],
                        },
                        {
                            text: ['Base URI', '/api/v1/OrderStates/{orderId}'],
                        },
                        {
                            text: ['Tipo de contenido', 'application/json'],
                        },
                        {
                            text: ['Headers'],
                            colspan: 2,
                            backgroundColor: '#ffcd34',
                            color: 'white',
                            textAlign: 'center'
                        },
                        {
                            text: ['Autorization', 'Bearer {Token}'],
                        },
                    ],
                },
            ],
        },
        submenu: [
            {
                menuTitle: 'Request',
                id: 'getStatus_request',
                content: {
                    subtitle: 'Request',
                    text: null,
                    table: [
                        {
                            header: [
                                [
                                    {
                                        text: 'Nombre de campo',
                                    },
                                    {
                                        text: 'Tipo',
                                    },
                                    {
                                        text: 'Descripción',
                                    },
                                ]
                            ],
                            data: [
                                {
                                    text: ['OrderId', 'long', 'Id de la orden en la plataforma'],
                                },
                            ],
                        },
                    ],
                    example: `GET /api/v1/OrderStates/202105265 HTTP/1.1\nContent-Type: application/json\nAuthorization: Bearer AQAAAN...thA`,
                }
            },
            {
                menuTitle: 'Response',
                id: 'getStatus_response',
                content: {
                    subtitle: 'Response',
                    table: [
                        {
                            header: [
                                [
                                    {
                                        text: 'Tipo de contenido',
                                    },
                                    {
                                        text: 'application/json',
                                        colspan: 2,
                                        backgroundColor: 'white',
                                        color: '#4A4A4A'
                                    },
                                ],
                                [
                                    {
                                        text: 'Nombre de campo',
                                    },
                                    {
                                        text: 'Tipo',
                                    },
                                    {
                                        text: 'Descripcion',
                                    },
                                ]
                            ],
                            data: [
                                {
                                    text: ['Id', 'long', 'Id del estado'],
                                },
                                {
                                    text: ['Name', 'string', 'Nombre del estado'],
                                },
                                {
                                    text: ['TimeStamp', 'string', 'Fecha del cambio de estado'],
                                },
                            ],
                        },
                    ],
                    example:
                        `HTTP/1.1 200 OK\nContent-Type: application/json\n\n[{\n   "id": 1,\n   "name": "created",\n   "timeStamp": "2022-01-06T18:07:53.497"\n},\n{\n   "id": 15,\n   "name": "reservation_confirmed",\n   "timeStamp": "2022-01-06T19:34:40.283"\n},\n{\n   "id": 10,\n   "name": "reservation_deposited",\n   "timeStamp": "2022-01-07T12:20:30.363"\n},\n{\n   "id": 11,\n   "name": "reservation_collected",\n   "timeStamp": "2022-01-07T17:50:48.887"\n}]\n`
                }
            },
        ]
    },
    {
        title: 'Obtención de locker',
        menuTitle: 'Obtención de locker',
        id: 'getLocker',
        content: {
            subtitle: null,
            text: 'Esta operación permite obtener todos los Smart Lockers disponibles.',
            table: [
                {
                    header: [
                        [
                            {
                                text: 'Invocación',
                                colspan: 2
                            },
                        ]
                    ],
                    data: [
                        {
                            text: ['Método', 'GET'],
                        },
                        {
                            text: ['Base URI', '/api/v1/Lockers'],
                        },
                        {
                            text: ['Tipo de contenido', 'application/json'],
                        },
                        {
                            text: ['Headers'],
                            colspan: 2,
                            backgroundColor: '#ffcd34',
                            color: 'white',
                            textAlign: 'center'
                        },
                        {
                            text: ['Autorization', 'Bearer {Token}'],
                        },
                    ],
                },
            ],
        },
        submenu: [
            {
                menuTitle: 'Request',
                id: 'getLocker_request',
                content: {
                    subtitle: 'Request',
                    text: null,
                    table: [
                        {
                            header: [
                                [
                                    {
                                        text: 'Nombre de campo',
                                    },
                                    {
                                        text: 'Tipo',
                                    },
                                    {
                                        text: 'Descripción',
                                    },
                                ]
                            ],
                            data: [
                                {
                                    text: ['', '', ''],
                                },
                            ],
                        },
                    ],
                    example: `GET /api/v1/lockers HTTP/1.1\nContent-Type: application/json\nAuthorization: Bearer AQAAAN...thA`,
                }
            },
            {
                menuTitle: 'Response',
                id: 'getLocker_response',
                content: {
                    subtitle: 'Response',
                    table: [
                        {
                            header: [
                                [
                                    {
                                        text: 'Tipo de contenido',
                                    },
                                    {
                                        text: 'application/json',
                                        colspan: 2,
                                        backgroundColor: 'white',
                                        color: '#4A4A4A'
                                    },
                                ],
                                [
                                    {
                                        text: 'Nombre de campo',
                                    },
                                    {
                                        text: 'Tipo',
                                    },
                                    {
                                        text: 'Descripcion',
                                    },
                                ]
                            ],
                            data: [
                                {
                                    text: ['Id', 'long', 'Id del Smart Locker'],
                                },
                                {
                                    text: ['Name', 'string', 'Nombre del Smart Locker'],
                                },
                                {
                                    text: ['Latitude', 'Double', 'Coordenada geográfica Norte Sur'],
                                },
                                {
                                    text: ['Longitud', 'Double', 'Coordenada geográfica Este Oeste'],
                                },
                                {
                                    text: ['LockerAddress', 'LockerAddressModel', 'Dirección del Smart Locker'],
                                },
                            ],
                        },
                        {
                            header: [
                                [
                                    {
                                        text: 'LockerAddressModel',
                                        colspan: 3,
                                        backgroundColor: 'white',
                                        color: '#4A4A4A'
                                    },
                                ],
                                [
                                    {
                                        text: 'Nombre de campo',
                                    },
                                    {
                                        text: 'Tipo',
                                    },
                                    {
                                        text: 'Descripción',
                                    },
                                ],
                            ],
                            data: [
                                {
                                    text: ['Address', 'string', 'Dirección física'],
                                },
                                {
                                    text: ['City', 'string', 'Ciudad'],
                                },
                                {
                                    text: ['Province', 'string', 'Provincia'],
                                },
                                {
                                    text: ['PostalCode', 'string', 'Código Postal'],
                                },
                            ],
                        },
                    ],
                    example:
                        `HTTP/1.1 200 OK\nContent-Type: application/json\n[{\n   "id": 9,\n   "name": "Carrefour Express Microcentro",\n   "latitude": -34.6010848372845,\n   "longitude": -58.3787561180022,\n   "lockerAddress": {\n      "address": "Tucuman 831 - C1049 - CABA",\n      "city": "CABA",\n      "province": "Ciudad Autónoma de Buenos Aires",\n      "zipCode": "C1049"\n   }\n},\n{\n   "id": 10,\n   "name": "Carrefour Escobar",\n   "latitude": -34.3441108169079,\n   "longitude": -58.7897593428668,\n   "lockerAddress": {\n      "address": "Mateo Gelves 530 - B1625 - Belén de Escobar",\n      "city": "AMBA",\n      "province": "Buenos Aires",\n      "zipCode": "B1625"\n   }\n}]\n`
                }
            },
        ]
    },
    {
        title: 'Obtención de código de recuperación de paquete cancelado',
        menuTitle: 'Obtención de código de recuperación de paquete cancelado',
        id: 'getAbandonedCollectCode',
        content: {
            subtitle: null,
            text: 'Esta operación permite obtener el código de recupero de un paquete cancelado que se encuentra depositado en locker',
            table: [
                {
                    header: [
                        [
                            {
                                text: 'Invocación',
                                colspan: 2
                            },
                        ]
                    ],
                    data: [
                        {
                            text: ['Método', 'GET'],
                        },
                        {
                            text: ['Base URI', '/api/v1/order/{platformOrderId}/abandonedCollectCode'],
                        },
                        {
                            text: ['Tipo de contenido', 'application/json'],
                        },
                        {
                            text: ['Headers'],
                            colspan: 2,
                            backgroundColor: '#ffcd34',
                            color: 'white',
                            textAlign: 'center'
                        },
                        {
                            text: ['Autorization', 'Bearer {Token}'],
                        },
                    ],
                },
            ],
        },
        submenu: [
            {
                menuTitle: 'Request',
                id: 'getAbandonedCollectCode_request',
                content: {
                    subtitle: 'Request',
                    text: null,
                    table: [
                        {
                            header: [
                                [
                                    {
                                        text: 'Nombre de campo',
                                    },
                                    {
                                        text: 'Tipo',
                                    },
                                    {
                                        text: 'Descripción',
                                    },
                                ]
                            ],
                            data: [
                                {
                                    text: ['OrderId', 'long', 'Id de la orden en la plataforma'],
                                },
                            ],
                        },
                    ],
                    example: `GET /api/v1/order/202106181/abandonedCollectCode HTTP/1.1\nContent-Type: application/json\nAuthorization: Bearer AQAAAN...thA`,
                }
            },
            {
                menuTitle: 'Response',
                id: 'getAbandonedCollectCode_response',
                content: {
                    subtitle: 'Response',
                    text: 'La respuesta es el código de recupero del paquete cancelado.',
                    example:
                        `HTTP/1.1 200 OK\n"RL8HBY"`
                }
            },
        ]
    },
    {
        title: 'Webhooks',
        menuTitle: 'Webhooks',
        id: 'webhooks',
        content: {
            subtitle: null,
            text: 'Además del seguimiento del pedido desde la url de seguimiento también se pueden obtener las novedades del paquete y la reserva a través del uso de webhooks. Esta funcionalidad está disponible mediante la subscripción a los distintos eventos que deseen ser notificados.',
        },
        submenu: [
            {
                menuTitle: 'Parámetros',
                id: 'webhooks_parameters',
                content: {
                    subtitle: 'Parámetros',
                    text: 'La llamada se realizará mediante un POST a la url indicada en la subscripción al evento. Se enviarán los siguientes parámetros en formato JSON.',
                    table: [
                        {
                            header: [
                                [
                                    {
                                        text: 'Tipo de contenido',
                                    },
                                    {
                                        text: 'application/json',
                                        colspan: 2,
                                        backgroundColor: 'white',
                                        color: '#4A4A4A'
                                    },
                                ],
                                [
                                    {
                                        text: 'Nombre de campo',
                                    },
                                    {
                                        text: 'Tipo',
                                    },
                                    {
                                        text: 'Descripcion',
                                    },
                                ]
                            ],
                            data: [
                                {
                                    text: ['OrderId', 'integer', 'Id de la orden especificado en el parámetro OrderId al momento de crear la orden'],
                                },
                                {
                                    text: ['Event', 'string', 'Nombre del evento'],
                                },
                                {
                                    text: ['TimeStamp', 'string', 'Fecha y hora del evento en formato dd/mm/yyyy HH:mm:ss'],
                                },
                            ],
                        },
                    ],
                    example:
                        `{\n   "orderId": 2022080902,\n   "event": "out_for_delivery",\n    "timeStamp": "8/10/2022 11:16:38 AM"\n}`

                },
            },
            {
                menuTitle: 'Eventos disponibles a suscripción',
                id: 'webhooks_events',
                content: {
                    subtitle: 'Eventos disponibles a suscripción',
                    text: 'Permite obtener los eventos que están disponibles para ser informados.',
                    table: [
                        {
                            header: [
                                [
                                    {
                                        text: 'Invocación',
                                        colspan: 2
                                    },
                                ]
                            ],
                            data: [
                                {
                                    text: ['Método', 'GET'],
                                },
                                {
                                    text: ['Base URI', '/api/v1/webhooks/definitions'],
                                },
                                {
                                    text: ['Tipo de contenido', 'application/json'],
                                },
                                {
                                    text: ['Headers'],
                                    colspan: 2,
                                    backgroundColor: '#ffcd34',
                                    color: 'white',
                                    textAlign: 'center'
                                },
                                {
                                    text: ['Autorization', 'Bearer {Token}'],
                                },
                            ],
                        },
                    ],
                    example:
                        `GET /api/v1/webhooks/definitions HTTP/1.1\nContent-Type: application/\nAuthorization: Bearer AQAAAN...thA`

                },
                submenu: [
                    {
                        menuTitle: 'Response',
                        id: 'webhooks_events_Response',
                        content: {
                            subtitle: 'Response',
                            table: [
                                {
                                    header: [
                                        [
                                            {
                                                text: 'Tipo de contenido',
                                            },
                                            {
                                                text: 'application/json',
                                                colspan: 2,
                                                backgroundColor: 'white',
                                                color: '#4A4A4A'
                                            },
                                        ],
                                        [
                                            {
                                                text: 'Nombre de campo',
                                            },
                                            {
                                                text: 'Tipo',
                                            },
                                            {
                                                text: 'Descripcion',
                                            },
                                        ]
                                    ],
                                    data: [
                                        {
                                            text: ['Name', 'String', 'Nombre del evento'],
                                        },
                                        {
                                            text: ['DisplayName', 'String', 'Nombre a mostrar'],
                                        },
                                        {
                                            text: ['Description', 'String', 'Breve descripción del evento'],
                                        },
                                    ],
                                },
                            ],
                            example:
                                `[\n   {\n      "name": "created",\n      "displayName": "Creado",\n      "description": "Se creó la orden"\n   },\n   {\n      "name": "parcel_pickup",\n      "displayName": "Retirado por PUDO",\n      "description": "El paquete fue retirado de la tienda por PUDO"\n   },\n   {\n      "name": "arrival_at_facility",\n      "displayName": "En depósito",\n      "description": "El paquete se encuentra en el depósito de PUDO"\n   }\n   …\n]`
                        }
                    },
                ]
            },
            {
                menuTitle: 'Suscripción a uno o varios eventos',
                id: 'webhooks_eventsSubscription',
                content: {
                    subtitle: 'Suscripción a uno o varios eventos',
                    table: [
                        {
                            header: [
                                [
                                    {
                                        text: 'Invocación',
                                        colspan: 2
                                    },
                                ]
                            ],
                            data: [
                                {
                                    text: ['Método', 'POST'],
                                },
                                {
                                    text: ['Base URI', '/api/v1/webhooks/subscriptions'],
                                },
                                {
                                    text: ['Tipo de contenido', 'application/json'],
                                },
                                {
                                    text: ['Headers'],
                                    colspan: 2,
                                    backgroundColor: '#ffcd34',
                                    color: 'white',
                                    textAlign: 'center'
                                },
                                {
                                    text: ['Autorization', 'Bearer {Token}'],
                                },
                            ],
                        },
                    ],
                },
                submenu: [
                    {
                        menuTitle: 'Request',
                        id: 'webhooks_eventsSubscription_request',
                        content: {
                            subtitle: 'Request',
                            table: [
                                {
                                    header: [
                                        [
                                            {
                                                text: 'Nombre de campo',
                                            },
                                            {
                                                text: 'Tipo',
                                            },
                                            {
                                                text: 'Descripcion',
                                            },
                                        ]
                                    ],
                                    data: [
                                        {
                                            text: ['Events', 'Array<string>', 'Nombres de los eventos a los cuales se desea subscribir'],
                                        },
                                        {
                                            text: ['Url', 'String', 'URL válida dónde se recibirán las novedades'],
                                        },
                                    ],
                                },
                            ],
                            example:
                                `POST /api/v1/webhooks/subscriptions HTTP/1.1\nContent-Type: application/json\nAuthorization: Bearer AQAAAN...thA\n{\n   "events": ["created", "parcel_pickup"],\n   "url": "https://url.com/example"\n}`
                        }
                    },
                    {
                        menuTitle: 'Response',
                        id: 'webhooks_eventsSubscription_Response',
                        content: {
                            subtitle: 'Response',
                            table: [
                                {
                                    header: [
                                        [
                                            {
                                                text: 'Tipo de contenido',
                                            },
                                            {
                                                text: 'application/json',
                                                colspan: 2,
                                                backgroundColor: 'white',
                                                color: '#4A4A4A'
                                            },
                                        ],
                                        [
                                            {
                                                text: 'Nombre de campo',
                                            },
                                            {
                                                text: 'Tipo',
                                            },
                                            {
                                                text: 'Descripcion',
                                            },
                                        ]
                                    ],
                                    data: [
                                        {
                                            text: ['CreatedAt', 'String', 'Fecha de subscripción'],
                                        },
                                        {
                                            text: ['UpdatedAt', 'String', 'Fecha de última actualización de la subscripción'],
                                        },
                                        {
                                            text: ['Id', 'Integer', 'Id de la subscripción'],
                                        },
                                        {
                                            text: ['Url', 'String', 'Url en la cual se notificarán evento'],
                                        },
                                        {
                                            text: ['Event', 'String', 'Nombre del evento al que se suscribió'],
                                        },
                                        {
                                            text: ['Active', 'Boolean', 'Estado de la suscripción'],
                                        },
                                    ],
                                },
                            ],
                            example:
                                `HTTP/1.1 200 OK\nContent-Type: application/json\n[\n   {\n   }   }"createAt": "2022-08-12T11:14:39.6348142",\n   }   }"updateAt": null,\n   }   "event": "created",\n      "id": 17,\n      "url": "https://url.com/example",\n      "active": true\n   },\n   {\n      "createAt": "2022-08-12T11:14:39.6727906",\n      "updateAt": null,\n      "event": "parcel_pickup",\n      "id": 18,\n      "url": "https://url.com/example",\n      "active": true\n   }\n]`
                        }
                    },
                ]
            },
            {
                menuTitle: 'Edición de una suscripción',
                id: 'webhooks_editSubscription',
                content: {
                    subtitle: 'Edición de una suscripción',
                    table: [
                        {
                            header: [
                                [
                                    {
                                        text: 'Invocación',
                                        colspan: 2
                                    },
                                ]
                            ],
                            data: [
                                {
                                    text: ['Método', 'PUT'],
                                },
                                {
                                    text: ['Base URI', '/api/v1/webhooks/subscriptions'],
                                },
                                {
                                    text: ['Tipo de contenido', 'application/json'],
                                },
                                {
                                    text: ['Headers'],
                                    colspan: 2,
                                    backgroundColor: '#ffcd34',
                                    color: 'white',
                                    textAlign: 'center'
                                },
                                {
                                    text: ['Autorization', 'Bearer {Token}'],
                                },
                            ],
                        },
                    ],
                },
                submenu: [
                    {
                        menuTitle: 'Request',
                        id: 'webhooks_editSubscription_request',
                        content: {
                            subtitle: 'Request',
                            table: [
                                {
                                    header: [
                                        [
                                            {
                                                text: 'Nombre de campo',
                                            },
                                            {
                                                text: 'Tipo',
                                            },
                                            {
                                                text: 'Descripcion',
                                            },
                                        ]
                                    ],
                                    data: [
                                        {
                                            text: ['Events', 'Array<string>', 'Nombres de los eventos a los cuales se desea subscribir'],
                                        },
                                        {
                                            text: ['Url', 'String', 'URL válida dónde se recibirán las novedades'],
                                        },
                                    ],
                                },
                            ],
                            example:
                                `PUT /api/v1/webhooks/subscriptions HTTP/1.1\nContent-Type: application/json\nAuthorization: Bearer AQAAAN...thA\n{\n   "events": ["created", "parcel_pickup"],\n   "url": "https://nueva-url.com/example"\n}`
                        }
                    },
                    {
                        menuTitle: 'Response',
                        id: 'webhooks_editSubscription_response',
                        content: {
                            subtitle: 'Response',
                            table: [
                                {
                                    header: [
                                        [
                                            {
                                                text: 'Tipo de contenido',
                                            },
                                            {
                                                text: 'application/json',
                                                colspan: 2,
                                                backgroundColor: 'white',
                                                color: '#4A4A4A'
                                            },
                                        ],
                                        [
                                            {
                                                text: 'Nombre de campo',
                                            },
                                            {
                                                text: 'Tipo',
                                            },
                                            {
                                                text: 'Descripcion',
                                            },
                                        ]
                                    ],
                                    data: [
                                        {
                                            text: ['CreatedAt', 'String', 'Fecha de subscripción'],
                                        },
                                        {
                                            text: ['UpdatedAt', 'String', 'Fecha de última actualización de la subscripción'],
                                        },
                                        {
                                            text: ['Id', 'Integer', 'Id de la subscripción'],
                                        },
                                        {
                                            text: ['Url', 'String', 'Url en la cual se notificarán evento'],
                                        },
                                        {
                                            text: ['Event', 'String', 'Nombre del evento al que se suscribió'],
                                        },
                                        {
                                            text: ['Active', 'Boolean', 'Estado de la suscripción'],
                                        },
                                    ],
                                },
                            ],
                            example:
                                `HTTP/1.1 200 OK\nContent-Type: application/json\n[\n   {\n      "createAt": "2022-08-12T11:14:39.6348142",\n      "updateAt": "2022-08-12T11:29:08.7910266",\n      "event": "created",\n      "id": 17,\n      "url": "https://url.com/example",\n      "active": true\n   },\n   {\n      "createAt": "2022-08-12T11:14:39.6727906",\n      "updateAt": "2022-08-12T11:29:08.80303",\n      "event": "parcel_pickup",\n      "id": 18,\n      "url": "https://url.com/example",\n      "active": true\n   }\n]`
                        }
                    },
                ]
            },
            {
                menuTitle: 'Baja de una suscripción',
                id: 'webhooks_unsubscribe',
                content: {
                    subtitle: 'Baja de una suscripción',
                    table: [
                        {
                            header: [
                                [
                                    {
                                        text: 'Invocación',
                                        colspan: 2
                                    },
                                ]
                            ],
                            data: [
                                {
                                    text: ['Método', 'DELETE'],
                                },
                                {
                                    text: ['Base URI', '/api/v1/webhooks/subscriptions'],
                                },
                                {
                                    text: ['Tipo de contenido', 'application/json'],
                                },
                                {
                                    text: ['Headers'],
                                    colspan: 2,
                                    backgroundColor: '#ffcd34',
                                    color: 'white',
                                    textAlign: 'center'
                                },
                                {
                                    text: ['Autorization', 'Bearer {Token}'],
                                },
                            ],
                        },
                    ],
                },
                submenu: [
                    {
                        menuTitle: 'Request',
                        id: 'webhooks_unsubscribe_request',
                        content: {
                            subtitle: 'Request',
                            table: [
                                {
                                    header: [
                                        [
                                            {
                                                text: 'Nombre de campo',
                                            },
                                            {
                                                text: 'Tipo',
                                            },
                                            {
                                                text: 'Descripcion',
                                            },
                                        ]
                                    ],
                                    data: [
                                        {
                                            text: ['Events', 'Array<string>', 'Nombres de los eventos que se desean dar de baja la subscripción'],
                                        },
                                    ],
                                },
                            ],
                            example:
                                `DELETE /api/v1/webhooks/subscriptions HTTP/1.1\nContent-Type: application/json\nAuthorization: Bearer AQAAAN...thA\n{\n   "events": ["created"],\n}`
                        }
                    },
                    {
                        menuTitle: 'Response',
                        id: 'webhooks_unsubscribe_response',
                        content: {
                            subtitle: 'Response',
                            table: [
                                {
                                    header: [
                                        [
                                            {
                                                text: 'Tipo de contenido',
                                            },
                                            {
                                                text: 'application/json',
                                                colspan: 2,
                                                backgroundColor: 'white',
                                                color: '#4A4A4A'
                                            },
                                        ],
                                        [
                                            {
                                                text: 'Nombre de campo',
                                            },
                                            {
                                                text: 'Tipo',
                                            },
                                            {
                                                text: 'Descripcion',
                                            },
                                        ]
                                    ],
                                    data: [
                                        {
                                            text: ['CreatedAt', 'String', 'Fecha de subscripción'],
                                        },
                                        {
                                            text: ['UpdatedAt', 'String', 'Fecha de última actualización de la subscripción'],
                                        },
                                        {
                                            text: ['Id', 'Integer', 'Id de la subscripción'],
                                        },
                                        {
                                            text: ['Url', 'String', 'Url en la cual se notificarán evento'],
                                        },
                                        {
                                            text: ['Event', 'String', 'Nombre del evento al que se suscribió'],
                                        },
                                        {
                                            text: ['Active', 'Boolean', 'Estado de la suscripción'],
                                        },
                                    ],
                                },
                            ],
                            example:
                                `HTTP/1.1 200 OK\nContent-Type: application/json\n\n[\n   {\n      "createAt": "2022-08-12T11:14:39.6348142",\n      "updateAt": "2022-08-12T11:29:08.7910266",\n      "event": "created",\n      "id": 17,\n      "url": "https://url.com/example",\n      "active": true\n   },\n   {\n      "createAt": "2022-08-12T11:14:39.6727906",\n      "updateAt": "2022-08-12T11:29:08.80303",\n      "event": "parcel_pickup",\n      "id": 18,\n      "url": "https://url.com/example",\n      "active": true\n   }\n]`
                        }
                    },
                ]
            },
            {
                menuTitle: 'Obtención de las suscripciones',
                id: 'webhooks_getSubscriptions',
                content: {
                    subtitle: 'Obtención de las suscripciones',
                    table: [
                        {
                            header: [
                                [
                                    {
                                        text: 'Invocación',
                                        colspan: 2
                                    },
                                ]
                            ],
                            data: [
                                {
                                    text: ['Método', 'GET'],
                                },
                                {
                                    text: ['Base URI', '/api/v1/webhooks/subscriptions'],
                                },
                                {
                                    text: ['Tipo de contenido', 'application/json'],
                                },
                                {
                                    text: ['Headers'],
                                    colspan: 2,
                                    backgroundColor: '#ffcd34',
                                    color: 'white',
                                    textAlign: 'center'
                                },
                                {
                                    text: ['Autorization', 'Bearer {Token}'],
                                },
                            ],
                        },
                    ],
                    example: `GET /api/v1/webhooks/subscriptions HTTP/1.1\nContent-Type: application/json\nAuthorization: Bearer AQAAAN...thA`
                },
                submenu: [
                    {
                        menuTitle: 'Response',
                        id: 'webhooks_getSubscriptions_response',
                        content: {
                            subtitle: 'Response',
                            table: [
                                {
                                    header: [
                                        [
                                            {
                                                text: 'Tipo de contenido',
                                            },
                                            {
                                                text: 'application/json',
                                                colspan: 2,
                                                backgroundColor: 'white',
                                                color: '#4A4A4A'
                                            },
                                        ],
                                        [
                                            {
                                                text: 'Nombre de campo',
                                            },
                                            {
                                                text: 'Tipo',
                                            },
                                            {
                                                text: 'Descripcion',
                                            },
                                        ]
                                    ],
                                    data: [
                                        {
                                            text: ['Name', 'String', 'Nombre del evento'],
                                        },
                                        {
                                            text: ['displayName', 'String', 'Nombre a mostrar del evento'],
                                        },
                                        {
                                            text: ['Description', 'String', 'Breve descripción del evento'],
                                        },
                                    ],
                                },
                            ],
                            example:
                                `[\n   {\n      "name": "created",\n      "displayName": "Creado",\n      "description": "Se creó la orden"\n   },\n   {\n      "name": "parcel_pickup",\n      "displayName": "Retirado por PUDO",\n      "description": "El paquete fue retirado de la tienda por PUDO"\n   }\n   {\n      "name": "arrival_at_facility",\n      "displayName": "En depósito",\n      "description": "El paquete se encuentra en el depósito de PUDO"\n   }\n      ...\n]`
                        }
                    },
                ]
            },
            {
                menuTitle: 'Verificación de webhooks',
                id: 'webhooks_verification',
                content: {
                    subtitle: 'Verificación de webhooks',
                    text: `Los webhooks recibidos pueden ser verificados mediante una firma. Cada Webhook inlcuye el Header  x-signed-hmac-sha256 el cual es generado usando el client-secret usado para obtener el token de autenticación junto con los datos enviados en el request.\nA continuación se muestra un ejemplo en C# de cómo  calcular la firma:`,
                    example: `public bool IsAuthenticWebhookRequest(Stream content, Encoding encoding, string hmac)\n   {\n      var data = GetStreamAsText(content, encoding);\n      var hmacHasher = new HMACSHA256(Encoding.UTF8.GetBytes(ClientSecret));\n      var hash = hmacHasher.ComputeHash(Encoding.UTF8.GetBytes(data));\n      var calculatedSignature = BitConverter.ToString(hash).Replace("-", "");\n      return calculatedSignature.ToUpper() == hmac.ToUpper();\n}`
                },

            },
            {
                menuTitle: 'Política de reintentos',
                id: 'webhooks_retry',
                content: {
                    subtitle: 'Política de reintentos',
                    text: `En caso de no obtener un response status code 200 (OK) por parte del cliente al hacer el request se reintentará enviar la novedad un máximo de 3 veces. Una vez alcanzado el máximo de reintentos, si no se pudo notificar correctamente la novedad ésta quedará sin volver a enviarse.\nDebido a los reintentos para enviar las novedades es posible que el orden en que sean notificadas se vea alterado. Por ejemplo: en un caso normal se notifica el evento de retiro del paquete por parte de Pudo (parcel_pickup) y posteriormente se notificaría el ingreso al depósito de Pudo (arrival_at_facility). Pero en el caso de que el primer evento falle al notificar y el segundo se notifique de forma exitosa, al volver a intentar notificar el primer evento y ser exitoso el orden se vería afectado (se informó primero arrival_at_facility y luego parcel_pickup). Es responsabilidad del cliente que consume el webhook manejar este escenario.`,
                },
            },
            {
                menuTitle: 'Lista de eventos a notificar',
                id: 'webhooks_eventsNotification',
                content: {
                    subtitle: 'Lista de eventos a notificar',
                    text: `A continuación se detalla brevemente los eventos a los cuales es posible subscribirse. Dicha lista se puede obtener la forma en que se detalla en el apartado “Eventos disponibles a subscripción”`,
                    table: [
                        {
                            header: [
                                [
                                    {
                                        text: 'Nombre',
                                    },
                                    {
                                        text: 'N a Mostrar',
                                    },
                                    {
                                        text: 'Descripción',
                                    },
                                ]
                            ],
                            data: [
                                {
                                    text: ['created', 'Creado', 'Se creó la órden'],
                                },
                                {
                                    text: ['parcel_pickup', 'Retirado por PUDO', 'El paquete fue retirado de la tienda por PUDO'],
                                },
                                {
                                    text: ['arrival_at_facility', 'En depósito', 'El paquete se encuentra en el depósito de PUDO'],
                                },
                                {
                                    text: ['waiting_reservation', 'Esperando reserva', 'Se espera a que se genera la reserva'],
                                },
                                {
                                    text: ['expired', 'Expirado', 'El tiempo de reserva ha expirado'],
                                },
                                {
                                    text: ['cancelled', 'Cancelado', 'Se canceló el paquete'],
                                },
                                {
                                    text: ['in_transit', 'En tránsito', 'El paquete se encuentra en tránsito entre depósitos de PUDO'],
                                },
                                {
                                    text: ['return_to_sender', 'Devolver a remitente', 'El paquete será devuelto al remitente'],
                                },
                                {
                                    text: ['out_for_delivery', 'En ruta de entrega', 'El paquete se encuentra en el último tramo de la entrega'],
                                },
                                {
                                    text: ['delivered', 'Entregado', 'El paquete fue entregado al destinatario (sólo envío a domicilio)'],
                                },
                                {
                                    text: ['deliver_attemp', 'Intento de Entrega', 'No se pudo entregar el paquete al destinatario (sólo envío a domicilio)'],
                                },
                                {
                                    text: ['reservation_deposited', 'Depositado', 'Se depositó el paquete en el locker'],
                                },
                                {
                                    text: ['reservation_collected', 'Retirado', 'El paquete fue retirado del locker'],
                                },
                                {
                                    text: ['reservation_expired', 'Expirado', 'El plazo de retiro del locker venció'],
                                },
                                {
                                    text: ['reservation_expires_soon', 'Próximo a expirar', 'El plazo de retiro del locker está por vencer'],
                                },
                                {
                                    text: ['reservation_abandoned_collected', 'Recolectado por PUDO', 'El paquete fue recuperado del locker por PUDO'],
                                },
                                {
                                    text: ['reservation_confirmed', 'Reserva confirmada', 'Se creó la reserva en el locker'],
                                },
                                {
                                    text: ['reservation_cancelled', 'Reserva cancelada', 'La reserva en el locker fue cancelada'],
                                },
                                {
                                    text: ['reservation_cancelled_collected', 'Reserva cancelada recolectada', 'Reserva cancelada recolectada'],
                                },
                                {
                                    text: ['reservation_deposited_expires_soon	', 'Próximo a expirar', 'El plazo de para depositar el paquete está por expirar'],
                                },
                                {
                                    text: ['reservation_deposited_expired', 'Expiró el tiempo de depósito', 'Expiró el tiempo para depositar el paquete'],
                                },
                            ]
                        },
                    ],
                },
            },
        ]
    },
    {
        title: 'Manejo de excepciones',
        menuTitle: 'Manejo de excepciones',
        id: 'exceptionHandling',
        content: {
            subtitle: null,
            text: `Al aplicar cualquier operación pueden ocurrir dos tipos de errores:\n      - Validaciones de Parámetros de Entrada \n      - Excepciones de Negocio \nCada uno de estos casos podrá diferenciarse fácilmente al utilizar un status code distinto.`,
        },
        submenu: [
            {
                menuTitle: 'Validaciones de parámetros de entrada',
                id: 'exceptionHandling_validation',
                content: {
                    subtitle: 'Validaciones de parámetros de entrada',
                    text: 'Al ocurrir un error de validación, el status code utilizado será Bad Request (400) y se retornará siguiente mensaje:',
                    table: [
                        {
                            header: [
                                [
                                    {
                                        text: 'Nombre de campo',
                                    },
                                    {
                                        text: 'Tipo',
                                    },
                                    {
                                        text: 'Descripción',
                                    },
                                ]
                            ],
                            data: [
                                {
                                    text: ['message', 'string', 'Mensaje de error'],
                                },
                                {
                                    text: ['modelState', 'ModelState', 'Esta estructura contiene una propiedad por cada campo y una lista de las validaciones fallidas.'],
                                },
                            ],
                        },
                    ],
                    example: `{\n   "message": "The request is invalid.",\n   "modelState": {\n      "request.Destination.City": [\n       }   }"The City field is required."\n   }   }],\n   }   }"request.Destination.Province": [\n   }   }   }"The Province field is required."\n   }   }]\n   }}\n}`,
                }
            },
            {
                menuTitle: 'Errores de negocio',
                id: 'exceptionHandling_businessError',
                content: {
                    subtitle: 'Errores de negocio',
                    text: 'Al ocurrir un error de validación, el status code utilizado será Internal Server Error (500) y se retornará siguiente mensaje:',
                    table: [
                        {
                            header: [
                                [
                                    {
                                        text: 'Nombre de campo',
                                    },
                                    {
                                        text: 'Tipo',
                                    },
                                    {
                                        text: 'Descripción',
                                    },
                                ]
                            ],
                            data: [
                                {
                                    text: ['GenericType', 'string', 'Tipo de error\n"UnhandledException": "Error de imprevisto"\n"ApplicationException":"Error de Aplicación"'],
                                },
                                {
                                    text: ['Type', 'string', 'Nombre completo de la excepción'],
                                },
                                {
                                    text: ['ShortType', 'string', 'Nombre corto de la excepción'],
                                },
                                {
                                    text: ['Message', 'string', 'Mensaje de error'],
                                },
                            ],
                        },
                    ],
                    example: `{\n   "GenericType": "ApplicationException",\n   "Type": "Exceptions.TransactionNotFound",\n   "ShortType": "TransactionNotFound",\n   "Message": "Transaccion no encontrada"\n} `,
                }
            },
            {
                menuTitle: 'Listado de excepciones de negocio',
                id: 'exceptionHandling_businessException',
                content: {
                    subtitle: 'Listado de excepciones de negocio',
                    table: [
                        {
                            header: [
                                [
                                    {
                                        text: 'ShortType',
                                    },
                                    {
                                        text: 'Descripción',
                                    },
                                ]
                            ],
                            data: [
                                {
                                    text: ['OrderAlreadyExists', 'La orden ya fue creada'],
                                },
                                {
                                    text: ['LockerNotFoundException', 'El locker enviado no se corresponde con un locker disponible en el sistema'],
                                },
                                {
                                    text: ['ServiceAreaNotFoundException', 'No se encontró un área de servicio definida para el método de envío y el código postal'],
                                },
                                {
                                    text: ['WarehouseNotFoundException', 'No se encontró un depósito configurado'],
                                },
                            ],
                        },
                    ],
                    example: `{\n   ;"GenericType": "ApplicationException",\n   ;"Type": "Exceptions.TransactionNotFound",\n   ;"ShortType": "TransactionNotFound",\n   ;"Message": "Transaccion no encontrada"\n}`,
                }
            },
        ]
    },
    {
        title: 'Gerencia de sistemas',
        menuTitle: 'Resumen de modificaciones',
        icon: <InfoRounded style={listIconStyles} />,
        id: 'modificationsSummary',
        content: {
            subtitle: 'Resumen de modificaciones',
            text: null,
            table: [
                {
                    header: [
                        [
                            {
                                text: 'Fecha',
                            },
                            {
                                text: 'Versión',
                            },
                            {
                                text: 'Autor',
                            },
                            {
                                text: 'Comentarios',
                            },
                        ]
                    ],
                    data: [
                        {
                            text: ['18.05.2021', 'Rev 01', 'Pudo Argentina S.A', 'Primera versión'],
                        },
                        {
                            text: ['21.06.2021', 'Rev 02', 'Pudo Argentina S.A', 'Agregado de ejemplos'],
                        },
                        {
                            text: ['27.07.2021', 'Rev 03', 'Pudo Argentina S.A', 'Ajustes de formato'],
                        },
                        {
                            text: ['08.09.2021', 'Rev 04', 'Pudo Argentina S.A', 'Corrección de path de autenticación y campos opcionales en la cotización'],
                        },
                        {
                            text: ['08.04.2021', 'Rev 05', 'Pudo Argentina S.A', 'Agregado de posibilidad de utilizar código de depósito propio de la tienda'],
                        },
                        {
                            text: ['10.08.2022', 'Rev 06', 'Pudo Argentina S.A', 'Implementación de envíos de webhooks'],
                        },
                        {
                            text: ['29.08.2022', 'Rev 07', 'Pudo Argentina S.A', 'Corrección de campos obligatorios'],
                        },
                        {
                            text: ['29.08.2022', 'Rev 08', 'Pudo Argentina S.A', 'Se agregan nuevos eventos al listado de eventos a notificar por webhooks'],
                        },
                        {
                            text: ['28.07.2023', 'Rev 09', 'Pudo Argentina S.A', 'Se agrega historial de estados de una orden y listado de Smart Lockers'],
                        },
                        {
                            text: ['04.09.2023', 'Rev 10', 'Pudo Argentina S.A', 'Se agrega la creación de órdenes integradas'],
                        },
                        {
                            text: ['19.08.2024', 'Rev 11', 'Pudo Argentina S.A', 'Se agrega la canceación de órdenes'],
                        },
                        {
                            text: ['21.11.2024', 'Rev 12', 'Pudo Argentina S.A', 'Se agrega la cancelación de órdenes con paquete depositado y obtención de código de cancelado'],
                        },
                        {
                            text: ['07.05.2025', 'Rev 13', 'Pudo Argentina S.A', 'Se agregan nuevos eventos al listado de eventos a notificar por webhooks'],
                        },
                    ]
                },
            ],
        }
    },
    {
        title: 'Anexo: Información sobre ambiente sandbox',
        menuTitle: 'Anexo: Información sobre ambiente sandbox',
        icon: <InfoRounded style={listIconStyles} />,
        id: 'attached_sandbox',
        content: {
            text: `La API cuenta con un ambiente sandbox para probar todos los métodos y validar que se estén invocando correctamente. Este ambiente no tiene contacto con el ambiente productivo y se reinicia luego de cierto tiempo.\nPara acceder a este ambiente, debe contactarse con PUDO, quien le suministrara las credenciales prueba y la URL correspondiente. \n\n Api ecommerce Sandbox url: \n https://ecommerceapipudo-sandbox.azurewebsites.net/api/token`
        }
    },
]

export default sections